import request from '@/utils/axios_gispai'
// import store from "../../store";

export function searchTeam(params) {
    return request({
        url: 'api/Team/searchTeam',
        method: 'post',
        data: params
    })
}
export function createTeam(params) {
    return request({
        url: 'api/Team/createTeam',
        method: 'get',
        params: params
    })
}
export function getTeamPat(params) {
    return request({
        url: 'api/Team/getTeamPat',
        method: 'post',
        data: params
    })
}
export function addPatByPhoenNum(params) {
    return request({
        url: 'api/Team/addPatByPhoenNum',
        method: 'get',
        params: params
    })
}
export function getTeamShareCode(params) {
    return request({
        url: 'api/Team/getTeamShareCode',
        method: 'get',
        params: params
    })
}
export function rebuildShareCode(params) {
    return request({
        url: 'api/Team/rebuildShareCode',
        method: 'get',
        params: params
    })
}
export function removeTeamPat(params) {
    return request({
        url: 'api/Team/removeTeamPat',
        method: 'get',
        params: params
    })
}
export function auditPat(params) {
    return request({
        url: 'api/Team/auditPat',
        method: 'get',
        params: params
    })
}

// 申请加入团队
export function addPatByShareCode(params) {
    return request({
        url: 'api/Team/addPatByShareCode',
        method: 'get',
        params: params
    })
}
export function getTeamPatByUser(params) {
    return request({
        url: 'api/Team/getTeamPatByUser',
        method: 'get',
        params: params
    })
}
export function getAllTeamPower(params) {
    return request({
        url: 'api/Team/getAllTeamPower',
        method: 'get',
        params: params
    })
}
export function addTeamRole(params) {
    return request({
        url: 'api/Team/addTeamRole',
        method: 'post',
        data: params
    })
}
export function getTeamRoles(params) {
    return request({
        url: 'api/Team/getTeamRoles',
        method: 'get',
        params: params
    })
}
export function updateTeamRole(params) {
    return request({
        url: 'api/Team/updateTeamRole',
        method: 'post',
        data: params
    })
}
export function deleteTeamRole(params) {
    return request({
        url: 'api/Team/deleteTeamRole',
        method: 'get',
        params: params
    })
}
export function updateTeamInfo(params) {
    return request({
        url: 'api/Team/updateTeamInfo',
        method: 'get',
        params: params
    })
}
export function searchTeamGroup(params) {
    return request({
        url: 'api/Team/searchTeamGroup',
        method: 'post',
        data: params
    })
}
export function addTeamGroup(params) {
    return request({
        url: 'api/Team/addTeamGroup',
        method: 'post',
        data: params
    })
}
export function getUserContainDetails(params) {
    return request({
        url: 'api/Team/getUserContainDetails',
        method: 'get',
        params: params
    })
}
export function addTeamGroupMember(params) {
    return request({
        url: 'api/Team/addTeamGroupMember',
        method: 'post',
        data: params
    })
}
export function deleteTeamGroupMember(params) {
    return request({
        url: 'api/Team/deleteTeamGroupMember',
        method: 'post',
        data: params
    })
}
export function deleteTeamGroup(params) {
    return request({
        url: 'api/Team/deleteTeamGroup',
        method: 'get',
        params: params
    })
}
export function getAllTeamGroup(params) {
    return request({
        url: 'api/Team/getAllTeamGroup',
        method: 'get',
        params: params
    })
}
export function saveGroupAndPat(params) {
    return request({
        url: 'api/Team/saveGroupAndPat',
        method: 'post',
        data: params
    })
}

export function getAllTeamGroupByUserId(params) {
    return request({
        url: 'api/Team/getAllTeamGroupByUserId',
        method: 'get',
        params: params
    })
}